import React from "react"

const FoodTypeSelector = ({ selectedFoodType, foodTypes, onChange }) => {
  const options = foodTypes.map(option => {
    return (
      <option key={option.slug} value={option.slug}>
        {option.name}
      </option>
    )
  })
  return (
    <>
      <label htmlFor="foodselector">Cuisine</label>
      <select
        valuename="foodselector"
        id="foodselector"
        name="foodselector"
        onChange={onChange}
        value={selectedFoodType}
      >
        <option value="">Choisir un type de cuisine</option>
        {options}
      </select>
    </>
  )
}

export default FoodTypeSelector
